import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_706';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Indique el valor recibido  ', listHelp: ['780'] },
  { text: "2", active: false, completed: false, tooltip: 'Parte exenta premios hípicos  ', listHelp: ['781'] }
];

@Component({
  selector: 'app-ganancias-ocasionales-premios-hipicos-modal',
  templateUrl: './ganancias-ocasionales-premios-hipicos-modal.component.html',
  styleUrls: ['./ganancias-ocasionales-premios-hipicos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class GananciasOcasionalesPremiosHipicosModalComponent extends HandlerModal implements OnInit {

  saveModel = new EventEmitter();
  public showSave:boolean;

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dialogRef: MatDialogRef<GananciasOcasionalesPremiosHipicosModalComponent>,
    public dNotificacionServicio:DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected inicializeModelo(){
    // if(this.model.doc.cuerpo.cs_id_779 == undefined)this.model.doc.cuerpo.cs_id_779=null;
    if(this.model.doc.cuerpo.cs_id_780 == undefined)this.model.doc.cuerpo.cs_id_780="0";
    if(this.model.doc.cuerpo.cs_id_781 == undefined)this.model.doc.cuerpo.cs_id_781="0";
    if(this.model.doc.cuerpo.cs_id_344 == undefined)this.model.doc.cuerpo.cs_id_344="0";
    if(this.model.doc.cuerpo.cs_id_706 == undefined)this.model.doc.cuerpo.cs_id_706="0";
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    // this.model.doc.cuerpo.cs_id_779=null;
    this.model.doc.cuerpo.cs_id_780="0";
    this.model.doc.cuerpo.cs_id_781="0";
    this.model.doc.cuerpo.cs_id_344="0";
    this.model.doc.cuerpo.cs_id_706="0";
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 780: this.OperacionCs780(); break;   
      case 781: this.OperacionCs781(); break;      

             
   }
   if(soloEstaCasilla)return;

   //Operaciones3
   let resultado = "0";
   
 }
   //valor del premio hipico o canino
OperacionCs780(){
   const cas780 = this.model.doc.cuerpo.cs_id_780;
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas780,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("El valor del premio no puede ser cero");
	  return
   }
   this.OperacionCs784();
}

//valor parte exenta premio hipico
OperacionCs781(){
	//no tiene validaciones
}


  //Calculo de impuesto de ganacia ocasional al 20%
OperacionCs784(){
  //validacion pendiente
  }
  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }
  
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }


}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-premios-hipicos-modal/ganancias-ocasionales-premios-hipicos-modal.component.ts